import React from "react";
import { Link } from "react-router-dom";
import rootDir from "../..";

interface Props {
    albumData: any;
    myRegion: string;
    searchRegion: string;
}

const AlbumList = ({albumData, myRegion, searchRegion}: Props) => {
    return (
        <table id="albumListTable" >
            <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th>Title</th>
                    <th>#</th>
                    <th>Year</th>
                    <th>Length</th>
                    <th>Label</th>
                    <th>Type</th>
                </tr>
            </thead>
            <tbody>
                { albumData ? Object.keys(albumData).map((i, j) => (
                    <tr key={i}>
                        <td title={albumData[i].album_id}>{albumData[i].album_cover ? <img src={albumData[i].album_cover} alt="cover" height={20} />:null}</td>
                        <td><Link to={rootDir+'album/'+albumData[i].album_id}
                            >{albumData[i].album_title}</Link></td>
                        <td>{albumData[i].no_of_tracks}</td>
                        <td>{albumData[i].album_year}</td>
                        <td>{albumData[i].time}</td>
                        <td>{albumData[i].album_label}</td>
                        <td>{albumData[i].album_type}</td>
                    </tr>
                )) : null }
            </tbody>
        </table>
    )
}

export default AlbumList